<dx-popup
    #addTransferAccountBox
    width="50%"
    height="50%"
    title="Select Transfer Accounts"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="transfer-account-content">
        <dx-box width="100%" height="100%" direction="col" *ngIf="!!transferAccountParam">
            <dxi-item [ratio]="1">
                <dx-form
                    #transferAccountForm
                    width="100%"
                    height="100%"
                    [colCount]="1"
                    [showValidationSummary]="true"
                    validationGroup="transferAccountData"
                    [labelLocation]="defaultLabelLocation"
                >
                    <dxi-item>
                        <dxo-label text="Community"></dxo-label>
                        <div *dxTemplate>
                            <app-multi-column-selector
                                #communitySelector
                                [name]="'Community'"
                                [gridSource]="communities"
                                [boxValue]="communityGridBoxValue"
                                [valueExpr]="'communityId'"
                                [displayExpr]="'communityName'"
                                [columnDef]="communityColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 'auto' }"
                                [showClearButton]="true"
                                [navigateToCommunity]="true"
                                [placeholder]="'Select Community...'"
                                [showHeaderFilters]="true"
                                (gridSelectionEvent)="onCommunitySelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Customer Type"></dxo-label>
                        <div *dxTemplate>
                            <div class="radio-group">
                                <dx-radio-group
                                    layout="horizontal"
                                    [items]="ownersType"
                                    [elementAttr]="{ class: 'owner-type-radio-group' }"
                                    [(value)]="selectedOwnersType"
                                ></dx-radio-group>
                            </div>
                        </div>
                    </dxi-item>

                    <dxi-item [isRequired]="true">
                        <dxo-label text="Account"></dxo-label>
                        <div *dxTemplate class="owner-accounts">
                            <dx-text-box
                                width="100%"
                                id="link"
                                stylingMode="outlined"
                                [showClearButton]="false"
                                [(value)]="searchText"
                                (onEnterKey)="onSearchClick()"
                            >
                                <dxi-button name="clear-search" location="after" [options]="clearButton"></dxi-button>
                                <dxi-button name="search" location="after" [options]="searchAccountButton"></dxi-button>
                            </dx-text-box>

                            <dx-popover
                                *ngIf="!!searchText && propertyCurrentOwners.length > 0"
                                target="#link"
                                position="top"
                                width="40%"
                                height="40%"
                                [shading]="true"
                                [(visible)]="accountSelectorVisible"
                            >
                                <div *dxTemplate="let data of 'content'">
                                    <dx-box height="100%" width="100%" direction="col" class="select-owner-box">
                                        <dxi-item [ratio]="1" class="select-owner-grid">
                                            <dx-data-grid
                                                width="100%"
                                                height="100%"
                                                [dataSource]="propertyCurrentOwners"
                                                [showBorders]="true"
                                                [showRowLines]="true"
                                                [rowAlternationEnabled]="true"
                                                [wordWrapEnabled]="true"
                                                [hoverStateEnabled]="true"
                                                [columnMinWidth]="30"
                                                [columnAutoWidth]="true"
                                                [allowColumnReordering]="true"
                                                [allowColumnResizing]="true"
                                                columnResizingMode="nextColumn"
                                                noDataText="No data to display"
                                            >
                                                <dxi-column
                                                    [width]="90"
                                                    caption="Action"
                                                    cellTemplate="actionCellTemplate"
                                                    alignment="center"
                                                    [showInColumnChooser]="false"
                                                ></dxi-column>
                                                <dxi-column
                                                    dataField="community"
                                                    dataType="string"
                                                    caption="Community"
                                                ></dxi-column>
                                                <dxi-column
                                                    dataField="owner"
                                                    dataType="string"
                                                    caption="Owner"
                                                ></dxi-column>
                                                <dxi-column
                                                    dataField="accountNumber"
                                                    dataType="string"
                                                    caption="Account #"
                                                ></dxi-column>
                                                <dxi-column
                                                    dataField="propertyAddress"
                                                    dataType="string"
                                                    caption="Property Address"
                                                ></dxi-column>

                                                <div *dxTemplate="let data of 'actionCellTemplate'">
                                                    <dx-button
                                                        stylingMode="contained"
                                                        text="Select"
                                                        type="default"
                                                        [width]="80"
                                                        (onClick)="onAccountSelect(data.data)"
                                                    ></dx-button>
                                                </div>

                                                <dxo-header-filter [visible]="false"></dxo-header-filter>
                                                <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                                                <dxo-group-panel [visible]="false"></dxo-group-panel>
                                                <dxo-sorting mode="none"></dxo-sorting>
                                                <dxo-scrolling mode="standard"></dxo-scrolling>
                                                <dxo-load-panel [enabled]="false"></dxo-load-panel>
                                            </dx-data-grid>
                                        </dxi-item>
                                    </dx-box>
                                </div>
                            </dx-popover>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Debit Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [(value)]="transferAccounts.debitAccountDescription"></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Credit Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [(value)]="transferAccounts.creditAccountInfo.description"></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item isRequired="true">
                        <dxo-label text="Transfer Amount"></dxo-label>
                        <div *dxTemplate>
                            <div class="transfer-amount">
                                <dx-number-box
                                    width="50%"
                                    [min]="minAmount"
                                    [format]="currencyFormat"
                                    [(value)]="transferAccounts.transferAmount"
                                ></dx-number-box>
                                <span class="available-amount">
                                    (Available for transfer: {{ availableAmount | ccCurrency }})
                                </span>
                            </div>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="closeIcon"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                [text]="actionButtonText"
                                useSubmitBehavior="true"
                                [icon]="addIcon"
                                (onClick)="onAddAccountClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#addTransferAccountBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
